/*
 * Most Visited Articles Actions
 */

import {
  LOAD_RECOMMENDATIONS,
  LOAD_RECOMMENDATIONS_PRODUCTS,
  LOAD_RECOMMENDATIONS_SUCCESS,
  LOAD_RECOMMENDATIONS_ERROR,
  LOAD_RECOMMENDATIONS_PRODUCTS_SUCCESS,
  LOAD_RECOMMENDATIONS_PRODUCTS_ERROR
} from "./constants";

/**
 * Load the repositories, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_REPOS
 */
export function loadRecommendations () {
  return {
    type: LOAD_RECOMMENDATIONS
  };
}

/**
 * Load recommendations for the most visited products on the platform
 *
 * @return {object} An action object with a type of LOAD_RECOMMENDATIONS_PRODUCTS
 */
export function loadRecommendationsProducts () {
  return {
    type: LOAD_RECOMMENDATIONS_PRODUCTS
  };
}

/**
 * Dispatched when the repositories are loaded by the request saga
 *
 * @param  {array} recommendations The repository data
 *
 * @return {object}      An action object with a type of LOAD_REPOS_SUCCESS passing the repos
 */
export function recommendationsLoaded (recommendations) {
  return {
    type: LOAD_RECOMMENDATIONS_SUCCESS,
    recommendations: recommendations.data
  };
}

export function recommendationsProductsLoaded (recommendations) {
  return {
    type: LOAD_RECOMMENDATIONS_PRODUCTS_SUCCESS,
    recommendations: recommendations.data
  };
}

/**
 * Dispatched when loading the repositories fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_REPOS_ERROR passing the error
 */
export function recommendationsLoadingError (error) {
  return {
    type: LOAD_RECOMMENDATIONS_ERROR,
    error
  };
}

export function recommendationsLoadingProductsError (error) {
  return {
    type: LOAD_RECOMMENDATIONS_PRODUCTS_ERROR,
    error
  };
}
